import { useState, useCallback } from 'react';
import { useApiFetch } from '../api';
import { PowerAction, PowerActionResult } from '../types/models/Server';
import { ApiResponsePowerAction } from '../types/api/ApiResponseServer';

interface UseServerPowerReturn {
  sendPowerAction: (serverId: number, action: PowerAction) => Promise<PowerActionResult>;
  loading: boolean;
  error: Error | null;
}

export const useServerPower = (): UseServerPowerReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const apiFetch = useApiFetch();

  const sendPowerAction = useCallback(
    async (serverId: number, action: PowerAction): Promise<PowerActionResult> => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiFetch(`/datacenters/servers/${serverId}/power`, {
          method: 'POST',
          body: JSON.stringify({ action }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = (await response.json()) as ApiResponsePowerAction;
        if (data.status === 'success') {
          return data.data;
        } else {
          throw new Error(data.message || 'Power action failed');
        }
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Power action failed');
        setError(error);
        throw error;
      } finally {
        setLoading(false);
      }
    },
    [apiFetch],
  );

  return { sendPowerAction, loading, error };
};
